import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function LinkElement({ children, className, element, ...props }: PlateElementProps) {
	return (
		<PlateElement
			{...props}
			element={element}
			as="a"
			className={cn(
				"cursor-pointer font-medium text-primary underline decoration-primary/40 underline-offset-4 hover:decoration-primary",
				className,
			)}
			{...(element.url
				? {
						href: element.url as string,
						target: "_blank",
						rel: "noopener noreferrer",
					}
				: {})}
		>
			{children}
		</PlateElement>
	);
}
